<template>
    <div>
        <div class="page-header clear-filter" filter-color="orange">
            <parallax
                    class="page-header-image"
                    style="background-image:url('img/bg5.jpg')"
            >
            </parallax>

        </div>
        <div class="section-detail">

            <div v-if="userModel.subItemListImage != ''" class="mt-3  text-center">
                <img :src="preUrl  + userModel.subItemListImage"
                     style="max-height: 15rem!important;"/>
            </div>
            <div v-for="useDataVms in userModel.useDataVms" :key="useDataVms.dataId">
                <!--SUB ITEM TITLE------------------------->
                <div class="d-flex px-5 mt-3 pb-0 mb-0">
                    <h4 class=" col-md-3 float-right  px-3">
                        {{useDataVms.subItemTitle}}
                        : </h4>
                </div>
                <div class="align-items-center px-5 text-center pb-0 mt-0">
                    <!-- ITEM DATA ---------------------------->
                    <!--<p class="btn btn-primary btn-lg col-md-3 float-right  px-3">{{useDataVms.subItemTitle}}</p>-->
                    <p class="btn btn-primary btn-lg col-md-8"
                       v-if="useDataVms.dataType === 1 && useDataVms.textData !==''">{{
                        useDataVms.textData}}</p>
                    <p class="btn btn-primary btn-lg col-md-8"
                       v-if="useDataVms.dataType === 2 && useDataVms.numberData!==0">{{
                        useDataVms.numberData}}</p>
                    <p class="btn btn-primary btn-lg col-md-8"
                       v-if="useDataVms.dataType === 3 && useDataVms.dateData!==''">
                        {{convertDate(useDataVms.dateData)}}
                    </p>
                    <p class="btn btn-primary btn-lg col-md-8"
                       v-if="useDataVms.dataType === 4 && useDataVms.floatData!==0">{{
                        useDataVms.floatData}}</p>
                    <p class="btn btn-primary btn-lg col-md-8"
                       v-if="useDataVms.dataType === 5 && useDataVms.htmlData!==''"
                       v-html="useDataVms.htmlData"></p>
                    <img class="  col-8"
                         v-if="useDataVms.dataType === 6 && useDataVms.imageData!==''"
                         :src="preUrl  + useDataVms.imageData"
                         style="max-height: 15rem!important;"/>


                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import Vue from 'vue'
    import BaseService from "../_framework/api/BaseService";
    import Moment from 'moment-jalali';
    import Utils from "../_framework/utils/Utils";
    import Constants from "../_framework/Constants";
    import {Card, Tabs, TabPane, Progress} from '@/components';
    import {Carousel, CarouselItem} from 'element-ui';
    import Router from "vue-router";

    // Vue.use(Router)
    // Vue.mixin({
    //     beforeRouteUpdate(to, from, next) {
    //         console.log("back kmnkmk")
    //         next('/');
    //     }
    // });

    export default {
        name: 'profileDetail',
        bodyClass: 'profile-page',
        components: {
            // Tabs,
            // Card,
            // TabPane,
            [Carousel.name]: Carousel,
            [CarouselItem.name]: CarouselItem,
            [Progress.name]: Progress,
        },
        data() {
            return {
                preUrl: Constants.BASE_URL,
                netMode: "",
                isLoading: false,
                userModel: {
                    useDataVms: [],
                },
                listId: 0,
                userId: 0,

            }
        },
        mounted() {
            this.listId = this.$route.params.listId;
            this.userId = Constants.USER_ID;
            this.getUserData();
        },
        methods: {
            getUserData() {
                this.isLoading = true;
                let p = {
                    userId: this.userId,
                    listId: this.listId
                };
                new BaseService("RezomeReport", "/GetUserDatasListId").getList(p).then(response => {
                    this.isLoading = false;

                    this.userModel = response.data;
                    // this.userModel.userData.userNewImage = this.validateImageUrl(this.userModel.userData.userImage)
                    // this.userModel.userData.userNewImage = Constants.BASE_URL + "/" + this.userModel.userData.userImage;
                    // console.log(this.userModel.userData.userNewImage);

                    // if (this.userModel.birthDay !== null) {
                    //     this.birthDay = Moment(this.gregorianToJalali(this.userModel.birthDay), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY');
                    // }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            convertDate(gdate) {
                return Moment(this.gregorianToJalali(gdate), 'jYYYY/jMM/jDD').format('jDD jMMMM jYYYY')
            },

        },
        // beforeRouteLeave(to, from, next) {
        //     console.log("leave")
        //     next('/');
        // },
        // beforeRouteEnter (to, from, next) {
        //     console.log("enter")
        //     // next('/');
        // },
        // beforeRouteUpdate (to, from, next) {
        //     console.log("update")
        //     next('/');
        // },


        // router.beforeRouteLeave((to, from, next) =>{
        //     next('/');
        // }),


    }
    ;
</script>
<style>

</style>
